import {
  MyServicesListingSociety,
  MyServicesListingInstallation,
  MyServicesListingFilter,
} from '@core/domain/model/services/my-services-listing.model';

export interface MyServicesState {
  listingData: {
    superData: Array<MyServicesListingSociety>;
    subData: Record<string, MyServicesListingInstallation[]>;
    filters: MyServicesListingFilter;
    error: null | string;
  };
}

export const myServicesInitialState: MyServicesState = {
  listingData: {
    superData: [],
    subData: {},
    filters: {
      pageIndex: 1,
      pageSize: 5,
    },
    error: null,
  },
};
